export const normalizeIndex = (index: number, length: number): number => {
  if (!length) {
    return 0;
  }

  if (index < 0) {
    return length - 1;
  }

  if (index >= length) {
    return 0;
  }

  return Math.round(index);
};

export const shouldLoadGalleryImage = ({
  imageIndex,
  activeIndex,
  lastIndex,
  slideLength,
  preloadRange = 1,
}: {
  imageIndex: number;
  activeIndex: number;
  lastIndex: number;
  slideLength: number;
  preloadRange?: number;
}): boolean => {
  if (slideLength <= 0) {
    return false;
  }

  const stableIndex = Number.isInteger(activeIndex) ? activeIndex : lastIndex;
  const normalizedActiveIndex = normalizeIndex(stableIndex, slideLength);

  for (let offset = -preloadRange; offset <= preloadRange; offset += 1) {
    const preloadIndex = normalizeIndex(normalizedActiveIndex + offset, slideLength);

    if (imageIndex === preloadIndex) {
      return true;
    }
  }

  return false;
};
